import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "34",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path fill=\"#fff\" d=\"M13 19.308V3v16.308Z\"></path><path stroke=\"#000\" stroke-linecap=\"square\" stroke-linejoin=\"round\" stroke-width=\"5\" d=\"M13 19.308V3\"></path><path stroke=\"#000\" stroke-linecap=\"square\" stroke-width=\"5\" d=\"m21.516 13.549-8.386 8.386-8.516-8.516\"></path><path fill=\"#fff\" d=\"M23 31H3h20Z\"></path><path stroke=\"#000\" stroke-linecap=\"square\" stroke-linejoin=\"round\" stroke-width=\"5\" d=\"M23 31H3\"></path>", 5)
const _hoisted_7 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_7))
}
export default { render: render }